import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Footer from "../components/footer"
import FrcBanner from "../components/frc-banner"
import LatestPost from "../components/latest-post"
import NavigationSpacer from "../components/navigation-spacer"
import RevealAnimation from "../components/reveal-animation"
import Seo from "../components/seo"

class Home extends React.Component {
    render() {
        return (
            <div className="main-page h-100">
                <Seo title="Home" />
                <section id="intro" className="container-fluid main-mh-100 mb-5">
                    <NavigationSpacer />
                    <div className="container h-100">
                        <div className="row h-50 justify-content-center">
                            <div className="col-lg-7 col-md-6">
                                <h1 className="main-reveal-text-short">Привет, я Михаил Электронщик (aka hack1exe).<br />Я занимаюсь всякой дичью когда мне скучно.</h1>
                                <div className="main-fade-in-animation">
                                    <p>А точнее:</p>
                                    <p>Программированием</p>
                                    <p>Музыкой</p>
                                    <p>Информационной безопасностью</p>
                                    <p>Электроникой</p>
                                    <p>И т.д</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-7 col-8">
                                <div className="main-fade-in-animation-delay-1">
                                    <StaticImage width={300} height={300} className="main-fit-element main-circle" src="https://github.com/hack1exe.png" alt="Portrait" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 offset-md-1">
                                <div className="main-fade-in-animation-delay-2">
                                    <LatestPost />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
              {/*}  <section id="skills" className="container-fluid mb-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-10 ">
                                <RevealAnimation animationClass="main-reveal-text">
                                    <h1>Certifications</h1>
                                </RevealAnimation>
                            </div>
                        </div>
                        <RevealAnimation animationClass="main-fade-in-animation">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-3 col-sm-4 col-5">
                                    <a aria-label="Offensive Security Certified Professional on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/dd8f0eb6-b98c-4207-a4e2-0f0f8bc17df2">
                                        <StaticImage width={256} height={256} className="main-badge" src="../img/OSCP.png" alt="Offensive Security Certified Professional" />
                                    </a>
                                </div>
                                <div className="col-md-7 col-12">
                                    <div className="row justify-content-center">
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA IT Fundamentals on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/034299de-42cb-4a21-a645-54c9b17b94c2">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/ITF.png" alt="CompTIA ITF+" />
                                            </a>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA A+ on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/9e693b84-8452-488c-aaf3-16e77b41ced7">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/A.png" alt="CompTIA A+" />
                                            </a>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA Network+ on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/7e83577c-5acb-4fcc-89b6-2c81b58d63e4">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/Network.png" alt="CompTIA Network+" />
                                            </a>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA Security+ on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/76488e94-7792-404b-91cb-aabc7952c02f">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/Security.png" alt="CompTIA Security+" />
                                            </a>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA IT Operations Specialist on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/5f2a4560-2a6e-41e4-9dc8-8f0bddd6d459">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/CIOS.png" alt="CompTIA IT Operations Specialist" />
                                            </a>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                            <a aria-label="CompTIA Secure Infrastructure Specialist on Credly" target="_blank" rel="noopener noreferrer" href="https://www.credly.com/badges/e604fdf1-44b5-4e8f-9562-bf4da5e9800c">
                                                <StaticImage width={200} height={200} className="main-badge" src="../img/CSIS.png" alt="CompTIA Secure Infrastructure Specialist" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </RevealAnimation>
                    </div>
                </section>
                <section id="experiences" className="container-fluid mb-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="d-inline-block">
                                    <RevealAnimation animationClass="main-reveal-text">
                                        <h1>Experiences</h1>
                                    </RevealAnimation>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="d-inline-block">
                                    <RevealAnimation animationClass="main-reveal-text">
                                        <p className="h5">Achievements</p>
                                    </RevealAnimation>
                                </div>
                                <RevealAnimation animationClass="main-fade-in-animation">
                                    <ul>
                                        <li><a aria-label="DEF CON 30 YouTube video" target="_blank" rel="noopener noreferrer" href="https://youtu.be/3PAauAy-Fb4">DEF CON 30 Speaker</a></li>
                                        <li><a aria-label="CVE-2021-42109 on NVD" target="_blank" rel="noopener noreferrer" href="https://nvd.nist.gov/vuln/detail/CVE-2021-42109">CVE-2021-42109</a></li>
                                        <li><a aria-label="CP-XIII National Finals program" target="_blank" rel="noopener noreferrer" href="https://www.uscyberpatriot.org/Documents/CP-XIII%20National%20Finals%20Program.pdf">CyberPatriot National Finalist</a></li>
                                        <li><a aria-label="National Cyber Scholarship website" target="_blank" rel="noopener noreferrer" href="https://www.nationalcyberscholarship.org/winners-2021#block-yui_3_17_2_1_1620649009028_757451">National Cyber Scholar with Honor</a></li>
                                    </ul>
                                </RevealAnimation>
                                <div className="d-inline-block">
                                    <RevealAnimation animationClass="main-reveal-text">
                                        <p className="h5">Academics</p>
                                    </RevealAnimation>
                                </div>
                                <RevealAnimation animationClass="main-fade-in-animation">
                                    <ul>
                                        <li>National Honor Society</li>
                                        <li>National Technical Honor Society</li>
                                        <li>AP Scholar with Distinction</li>
                                        <li>Illinois State Scholar</li>
                                        <li>RMHS '21 Graduate with Highest Honors</li>
                                        <li>RMHS '21 Information Technology Senior Medallion</li>
                                    </ul>
                                </RevealAnimation>
                                <div className="d-inline-block">
                                    <RevealAnimation animationClass="main-reveal-text">
                                        <p className="h5">CyberPatriot</p>
                                    </RevealAnimation>
                                </div>
                                <RevealAnimation animationClass="main-fade-in-animation">
                                    <ul>
                                        <li>CyberPatriot X - 3rd Place Illinois</li>
                                        <li>CyberPatriot XI - Semifinalist, 2nd Place Illinois</li>
                                        <li>CyberPatriot XII - Semifinalist, 2nd Place Illinois</li>
                                        <li>CyberPatriot XIII - National Finalist (Top 12), 1st Place Illinois</li>
                                    </ul>
                                </RevealAnimation>
                                <div className="d-inline-block">
                                    <RevealAnimation animationClass="main-reveal-text">
                                        <p className="h5">CTF Competitions</p>
                                    </RevealAnimation>
                                </div>
                                <RevealAnimation animationClass="main-fade-in-animation">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Rank</th>
                                                <th>Team or Alias</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr><td>NCL Spring 2018 Preseason</td><td>789 / 3124</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>NCL Spring 2018 Individual Game</td><td>577 / 2452</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>NCL Spring 2019 Preseason</td><td>104 / 4482</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>NCL Spring 2019 Individual Game</td><td>60 / 3607</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>ångstromCTF 2019</td><td>383 / 1570</td><td>verybad</td></tr>
                                            <tr><td>NCL Spring 2019 Team Game</td><td>61 / 548</td><td>101sec</td></tr>
                                            <tr><td>NCL Spring 2020 Preseason</td><td>9 / 5379</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>NCL Spring 2020 Individual Game</td><td>68 / 5357</td><td>White</td></tr>
                                            <tr><td>NCL Spring 2020 Team Game</td><td>97 / 925</td><td>101sec</td></tr>
                                            <tr><td>TJCTF 2020</td><td>474 / 1205</td><td>101sec</td></tr>
                                            <tr><td>LBC2 2021 Advanced Division</td><td> 4 / 16</td><td>101sec</td></tr>
                                            <tr><td>NCL Spring 2021 Preseason</td><td>11 / 5794</td><td>White</td></tr>
                                            <tr><td>NCL Spring 2021 Individual Game</td><td>5 / 4180</td><td>White</td></tr>
                                            <tr><td>National Cyber Scholarship Competition 2021</td><td>10 / 3277</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>CIHSCDC 2021</td><td>1 / 8</td><td>101sec</td></tr>
                                            <tr><td>TAMUctf 2021</td><td>31 / 343</td><td>ACS Sirius</td></tr>
                                            <tr><td>HackTheBox Cyber Apocalypse 2021</td><td>112 / 4740</td><td>bob</td></tr>
                                            <tr><td>FAUST CTF 2021</td><td>32 / 77</td><td>Applied Cybersecurity Society</td></tr>
                                            <tr><td>HSCTF 8</td><td>13 / 1162</td><td>icypete</td></tr>
                                            <tr><td>redpwnCTF 2021</td><td>3 / 1416</td><td>OpeOnlyOverflows</td></tr>
                                            <tr><td>UIUCTF 2021</td><td>Organizer</td><td>SIGPwny</td></tr>
                                            <tr><td>CSAW '21 Qualifiers</td><td>2 / 1214</td><td>SIGPwny</td></tr>
                                            <tr><td>PBjar CTF 2021</td><td>11 / 560</td><td>[sqrt(-1) + 1]</td></tr>
                                            <tr><td>Aviation ISAC Collegiate CTF</td><td>8 / 22</td><td>IrisSec</td></tr>
                                            <tr><td>pbctf 2021</td><td>26 / 210</td><td>IrisSec</td></tr>
                                            <tr><td>NCL Fall 2021 Preseason</td><td>2 / 6506</td><td>Minh@UIUC</td></tr>
                                            <tr><td>SIGPwny Fall CTF 2021</td><td>Organizer</td><td>SIGPwny</td></tr>
                                            <tr><td>NCL Fall 2021 Individual Game</td><td>103 / 6475</td><td>White</td></tr>
                                            <tr><td>MetaCTF Campus Party Canada CTF 2021</td><td>5 / 28</td><td>WhiteHoodHacker</td></tr>
                                            <tr><td>NCL Fall 2021 Team Game</td><td>8 / 3910</td><td>TNTECH</td></tr>
                                            <tr><td>CPTC 2021 Western Regional</td><td>N/A</td><td>UIUC</td></tr>
                                            <tr><td>MetaCTF CyberGames 2021</td><td>4 / 1343</td><td>SIGPwny</td></tr>
                                            <tr><td>Dragon CTF 2021</td><td>50 / 247</td><td>SIGPwny</td></tr>
                                            <tr><td>MetaRed International CTF 2021 - 5th Stage</td><td>4 / 144</td><td>SIGPwny</td></tr>
                                            <tr><td>Tracer FIRE 10 @ UIUC</td><td>1 / 13</td><td>table3</td></tr>
                                            <tr><td>CyberSEED 2022</td><td>3 / 119</td><td>SIGPwny</td></tr>
                                            <tr><td>PlaidCTF 2022</td><td>27 / 431</td><td>Cornfield Computer Crew</td></tr>
                                            <tr><td>Wolverine Security Conference CTF 2022</td><td>3 / 516</td><td>SIGPwny</td></tr>
                                            <tr><td>CrewCTF 2022</td><td>9 / 758</td><td>SIGPwny</td></tr>
                                            <tr><td>b01lers CTF 2022</td><td>4 / 653</td><td>SIGPwny</td></tr>
                                            <tr><td>CypherCon 2022 OSINT CTF</td><td>1 / 31</td><td>SIGPwny</td></tr>
                                            <tr><td>ångstromCTF 2022</td><td>92 / 1180</td><td>SIGPwny</td></tr>
                                            <tr><td>BYUCTF 2022</td><td>6 / 435</td><td>SIGPwny</td></tr>
                                            <tr><td>DEF CON CTF Qualifier 2022</td><td>76 / 470</td><td>Cornfield Computer Crew</td></tr>
                                        </tbody>
                                    </table>
                                </RevealAnimation>
                            </div>
                        </div>
                    </div>
                </section>
                https://gmail.us5.list-manage.com/subscribe/post?u=602886b7ffa91c629bc8d12a5&amp;id=3774b743fb
        {*/}
                <section id="subscribe" className="container-fluid mb-5">
                    <div className="container h-100">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center">
                                <div id="mc_embed_signup">
                                    <form action="this-dev-feature-is-not-work-now" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="form-inline" target="_blank" novalidate>
                                        <div id="mc_embed_signup_scroll" className="form-group">
                                            <div className="d-inline-block">
                                                <RevealAnimation animationClass="main-reveal-text">
                                                    <h1><label htmlFor="mce-EMAIL">Оставайтесь на связи!</label></h1>
                                                </RevealAnimation>
                                            </div>
                                            <br />
                                            <RevealAnimation animationClass="main-fade-in-animation">
                                                <div className="d-inline-flex">
                                                    <input type="email" defaultValue="" name="EMAIL" className="form-control" id="mce-EMAIL" placeholder="hello@example.com" required />
                                                    <div style={{position: "absolute", left: "-5000px"}} aria-hidden="true"><input type="text" name="b_602886b7ffa91c629bc8d12a5_3774b743fb" tabindex="-1" value="" /></div>
                                                    <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn main-btn-primary ms-2" onclick=""/>
                                                </div>
                                                <br />
                                                <small><em>Вы будете получать уведомления только о новых постах. Я не спамлю.</em></small>
                                            </RevealAnimation>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
    }
}

export default Home
